import { faLaptop } from "@fortawesome/free-solid-svg-icons";
import { GitBranch } from "react-feather";

// ============================================================
// SELECT BACKEND SERVER
// ============================================================
//
// IN = India
// MY = Malaysia
// KH = Cambodia
// LOCAL = Local XAMPP backend (this project's own /backend folder)
//
// Your React application can stay on:
// http://localhost:3000/
//
// Change ONLY this value to switch backend.
//
// ============================================================

// `npm run build-in` / `build-my` / `build-kh` (scripts/build-site.js) override this per server.
const RUN_SITE = process.env.REACT_APP_RUN_SITE || "KH"; // fallback for `npm start` (IN, MY, KH, LOCAL)


// ============================================================
// LOGIN / TENANT PATH
// ============================================================

var login_url = localStorage.getItem("url");

let ten_path;
let file_ten_path;
let dashboardR;
let path1;
let path2;
let path3;
let path4;
let inter_tenant_path;
let url;
let doc_url;
let inter_tenant_path_hr;

if (login_url) {

  if (login_url.includes("super_admin")) {

    file_ten_path = login_url;

    var super_str = login_url.split("/");

    doc_url = super_str[0] + "/";
    inter_tenant_path =
      super_str[0] + "/" + super_str[1] + "/";
    inter_tenant_path_hr =
      super_str[0] + "/" + super_str[1];

  } else {

    file_ten_path =
      login_url + "index.php/";

    doc_url =
      login_url + "/";

    var hr_str =
      file_ten_path.split("/");

    doc_url =
      hr_str[0] + "/" + hr_str[1] + "/";

    inter_tenant_path =
      hr_str[0] + "/" + hr_str[1] + "/";

    inter_tenant_path_hr =
      hr_str[0] + "/" + hr_str[1];
  }

} else {

  url =
    window.location.pathname;

  var str =
    url.split("/");


  if (str[1] === "t") {

    if (
      str[1] &&
      str[1] !== "undefined"
    ) {
      path1 =
        str[1] + "/";
    } else {
      path1 = "";
    }


    if (
      str[2] &&
      str[2] !== "undefined" &&
      str[2] !== "t"
    ) {
      path2 =
        str[2] + "/";
    } else {
      path2 = "";
    }


    path3 = "index.php";


    file_ten_path =
      path1 +
      path2 +
      path3;


    inter_tenant_path =
      path1 +
      path2;


    inter_tenant_path_hr =
      path1 +
      path2;


    doc_url =
      path1 +
      path2 +
      "/";

  } else {

    if (
      str[1] &&
      str[1] !== "undefined"
    ) {
      path1 =
        str[1] + "/";
    } else {
      path1 = "";
    }


    if (
      str[2] &&
      str[2] !== "undefined"
    ) {
      path2 =
        str[2];
    } else {
      path2 =
        "index.php";
    }


    file_ten_path =
      path1 +
      path2 +
      "/";


    inter_tenant_path =
      "";

    inter_tenant_path_hr =
      "";


    doc_url =
      path1 +
      path2 +
      "/";
  }
}


// ============================================================
// SERVER CONFIGURATION
// ============================================================

const SITE_CONFIG = {

  // ==========================================================
  // INDIA
  // ==========================================================

  IN: {

    COUNTRY: "IN",

    LOGIN_URL:
      "https://appin.workzonemalaysia.com/backend/super_admin/index.php/",

    BACKEND_URL:
      "https://appin.workzonemalaysia.com/backend/",

    SITE_URL:
      "https://appin.workzonemalaysia.com/backend/",

    ADMIN_DOCS_URL:
      "https://appin.workzonemalaysia.com/backend/super_admin/",

    CARREER_URL:
      "https://appin.workzonemalaysia.com/career/",

    CARREERCOMPANY_URL:
      "https://appin.workzonemalaysia.com/careercompany/",
  },


  // ==========================================================
  // MALAYSIA
  // ==========================================================

  MY: {

    COUNTRY: "MY",

    LOGIN_URL:
      "https://hrm.workzonemalaysia.com/backend/super_admin/index.php/",

    BACKEND_URL:
      "https://hrm.workzonemalaysia.com/backend/",

    SITE_URL:
      "https://hrm.workzonemalaysia.com/backend/",

    ADMIN_DOCS_URL:
      "https://hrm.workzonemalaysia.com/backend/super_admin/",

    CARREER_URL:
      "https://hrm.workzonemalaysia.com/career/",

    CARREERCOMPANY_URL:
      "https://hrm.workzonemalaysia.com/careercompany/",
  },


  // ==========================================================
  // LOCAL (XAMPP)
  // ==========================================================

  LOCAL: {

    COUNTRY: "LOCAL",

    LOGIN_URL:
      "http://localhost/appkh/backend/super_admin/index.php/",

    BACKEND_URL:
      "http://localhost/appkh/backend/",

    SITE_URL:
      "http://localhost/appkh/backend/",

    ADMIN_DOCS_URL:
      "http://localhost/appkh/backend/super_admin/",

    CARREER_URL:
      "http://localhost/appkh/career/",

    CARREERCOMPANY_URL:
      "http://localhost/appkh/careercompany/",
  },


  // ==========================================================
  // CAMBODIA
  // ==========================================================

  KH: {

    COUNTRY: "KH",

    LOGIN_URL:
      "https://appkh.wzone.biz/backend/super_admin/index.php/",

    BACKEND_URL:
      "https://appkh.wzone.biz/backend/",

    SITE_URL:
      "https://appkh.wzone.biz/backend/",

    ADMIN_DOCS_URL:
      "https://appkh.wzone.biz/backend/super_admin/",

    CARREER_URL:
      "https://appkh.wzone.biz/career/",

    CARREERCOMPANY_URL:
      "https://appkh.wzone.biz/careercompany/",
  }
};


// ============================================================
// ACTIVE SERVER
// ============================================================

const ACTIVE_CONFIG =
  SITE_CONFIG[RUN_SITE];


// Safety check
if (!ACTIVE_CONFIG) {
  throw new Error(
    "Invalid RUN_SITE. Use IN, MY, or KH."
  );
}


// ============================================================
// EXPORT URLS
// ============================================================

export const COUNTRY =
  ACTIVE_CONFIG.COUNTRY;

export const IS_LOCAL =
  RUN_SITE === "LOCAL";


export const LOGIN_URL =
  ACTIVE_CONFIG.LOGIN_URL;


export const BASE_URL =
  ACTIVE_CONFIG.BACKEND_URL +
  file_ten_path;


export const TENANT_PAGE_PATH =
  inter_tenant_path;


export const TENANT_PAGE_PATH_SUPER_ADMIN =
  "super_admin/index.php/";


export const DOCS_URL =
  ACTIVE_CONFIG.BACKEND_URL +
  doc_url;


export const PROMOTION =
  inter_tenant_path_hr;


export const SITE_URL =
  ACTIVE_CONFIG.SITE_URL;


export const ADMIN_DOCS_URL =
  ACTIVE_CONFIG.ADMIN_DOCS_URL;


export const CARREER_URL =
  ACTIVE_CONFIG.CARREER_URL;


export const CARREERCOMPANY_URL =
  ACTIVE_CONFIG.CARREERCOMPANY_URL;


// ============================================================
// INDIA TAX REGIME
// ============================================================

export const TAX_REGIME_OPTIONS = [
  {
    value: "old",
    label: "Old Tax Regime",
  },
  {
    value: "new",
    label: "New Tax Regime",
  },
];


// ============================================================
// MESSAGES
// ============================================================

export const ADDMSG =
  "Record Added Successfully";

export const UPDATEMSG =
  "Record Updated Successfully";

export const DELETEMSG =
  "Record Deleted Successfully";

export const ERRORMSG =
  "Can not Add the Record";

export const ADDMSGCHAT =
  "Msg Send Successfully";

export const ERRORMSGCHAT =
  "Msg Not Send Successfully";